<template>
  <basic-portlet title="Discovery" :no-shadow="borderless">
    <div class="row">
      <div class="col-12 col-md-6">
        <div v-if="itunes_categories.length" class="form-group">
          <label for="category"><strong>Category *</strong></label>
          <multiselect v-model="selected_itunes_category"
                       :options="itunes_categories"
                       track-by="id"
                       :searchable="true"
                       :show-labels="false"
                       label="name"
                       placeholder="Pick a Category"
                       @input="setItunesCategoryAndFilterSubCategories">
            <template #singleLabel="props">
              {{ props.option.name }} <span v-if="props.option.type === 2" class="legacy-label">legacy</span>
            </template>
            <template #option="props">
              {{ props.option.name }} <span v-if="props.option.type === 2" class="legacy-label">legacy</span>
            </template>
          </multiselect>
          <input v-model="selected_itunes_category"
                 v-validate="'required'"
                 data-vv-scope="discovery-form"
                 name="Category"
                 type="text"
                 class="d-none">
          <p v-show="errors.has('Category', 'discovery-form')" class="help text-ss-danger">
            {{ errors.first('Category', 'discovery-form') }}
          </p>
        </div>
        <div v-if="itunes_categories.length" v-show="itunes_subcategories_filtered.length" class="form-group">
          <label for="sub-category"><strong>Sub-Category</strong></label>
          <multiselect v-model="selected_itunes_subcategory"
                       :options="itunes_subcategories_filtered"
                       track-by="id"
                       :searchable="true"
                       :show-labels="false"
                       label="name"
                       placeholder="Pick a value"
                       @input="setItunesSubCategory">
            <template #singleLabel="props">
              {{ props.option.name }} <span v-if="props.option.type === 2"
                                            class="legacy-label">legacy</span>
            </template>
            <template #option="props">
              {{ props.option.name }} <span v-if="props.option.type === 2"
                                            class="legacy-label">legacy</span>
            </template>
          </multiselect>
        </div>
        <div class="form-group">
          <label for="website"><strong>Homepage URL<span id="website_url_tooltip" class="ml-2 la la-question-circle" /></strong></label>
          <b-tooltip target="website_url_tooltip" triggers="hover">
            <div v-sanitise="tooltips.website_url_tooltip" />
          </b-tooltip>
          <input id="website"
                 v-model="podcast.itunes_detail.link"
                 v-validate="{url: {require_protocol: true }}"
                 data-vv-scope="discovery-form"
                 name="Homepage Url"
                 type="text"
                 class="form-control"
                 placeholder="https://awesome-podcast.com">
          <p v-show="errors.has('Homepage Url', 'discovery-form')" class="help text-ss-danger">
            Homepage URL is not valid. Please include 'http://' or 'https://' prefix.
          </p>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="form-group">
          <label for="language"><strong>Language</strong></label>
          <multiselect v-model="podcast.itunes_detail.language"
                       name="Language"
                       :options="language_codes"
                       track-by="code"
                       :custom-label="languagesCustomLabel"
                       :searchable="true"
                       :show-labels="false"
                       placeholder="Pick a Language" />
        </div>
      </div>
    </div>
  </basic-portlet>
</template>
<script>
import BasicPortlet from "VueComponents/BasicPortlet";
import { mapWritableState } from 'pinia';
import { usePodcastManageStore } from "VueStore/app/podcastManage";
import PodcastManageMixin from "VueMixins/Feeds/PodcastManageMixin";
import PodcastValidateMixin from "VueMixins/PodcastValidateMixin";
import TooltipsMixin from "VueMixins/TooltipsMixin";

export default {
  components: { BasicPortlet },
  mixins: [PodcastManageMixin, PodcastValidateMixin, TooltipsMixin],
  props: {
    borderless: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      itunes_categories: [],
      selected_itunes_category: null,
      itunes_subcategories: [],
      selected_itunes_subcategory: null,
      itunes_subcategories_filtered: [],
    };
  },
  computed: {
    ...mapWritableState(usePodcastManageStore, ['podcast']),
    ...mapWritableState(usePodcastManageStore, ['language_codes']),
  },
  mounted() {
    this.getItunesCategories();
    this.getItunesSubcategories();
  },
  methods: {
    async getItunesCategories() {
      try {
        const response = await axios.get(`/api/v1/itunes/categories`);
        this.itunes_categories = response.data.data;

        if (this.podcast.itunes_detail?.itunes_category_id) {
          this.selected_itunes_category = _.find(this.itunes_categories, category => category.id === this.podcast.itunes_detail.itunes_category_id);
        }
      } catch (error) {
        toastr.error("Oops. Something went wrong when retrieving itunes categories");
      }
    },

    async getItunesSubcategories() {
      try {
        const response = await axios.get(`/api/v1/itunes/subcategories`);
        this.itunes_subcategories = response.data.data;

        if (this.podcast.itunes_detail?.itunes_subcategory_id) {
          this.selected_itunes_subcategory = _.find(this.itunes_subcategories, subcategory => subcategory.id === this.podcast.itunes_detail.itunes_subcategory_id);
          this.itunes_subcategories_filtered = _.filter(this.itunes_subcategories, {
            'itunes_category_id': this.podcast.itunes_detail.itunes_category_id,
          });
        }
      } catch (error) {
        toastr.error("Oops. Something went wrong when retrieving subcategories");
      }
    },

    setItunesCategoryAndFilterSubCategories(selected_category) {
      this.selected_itunes_subcategory = null;
      // Category has been removed.
      if (!selected_category) {
        this.podcast.itunes_detail.itunes_category_id = null;
        this.podcast.itunes_detail.itunes_subcategory_id = null;
        this.itunes_subcategories_filtered = [];
        return;
      }

      // If the category has changed, forget the subcategory.
      if (this.podcast.itunes_detail.itunes_category_id !== selected_category.id) {
        this.podcast.itunes_detail.itunes_subcategory_id = null;
      }

      this.podcast.itunes_detail.itunes_category_id = selected_category.id;
      this.itunes_subcategories_filtered = _.filter(this.itunes_subcategories, {
        'itunes_category_id': selected_category.id,
      });
    },

    setItunesSubCategory(selected_subcategory) {
      if (selected_subcategory) {
        this.podcast.itunes_detail.itunes_subcategory_id = selected_subcategory.id;
        return;
      }
      this.podcast.itunes_detail.itunes_subcategory_id = null;
    },
  },
};
</script>
